<template>
  <div class="received-log-box">
    <div class="received-log-box__received-at-area">
      <div class="received-log-box__received-at">
        {{ formattedReceivedDate }}
      </div>
    </div>

    <div class="received-log-box__contents" @click="moveReceivedGift">
      <div class="contents__header">
        <AccountIconWh24 :image-url="senderIconImageUrl" />
        <div class="contents__caption-area">
          <div class="contents__caption caption-bold">
            <div class="contents__sender-name">
              {{ senderName }}
            </div>
          </div>
          <div class="contents__caption-suffix">
            さんからギフトを受け取りました
          </div>
        </div>
      </div>
      <div class="contents__body">
        <div class="contents__card-design-image-url">
          <img :src="cardDesignImageUrl" alt="カードデザイン画像URL" />
        </div>
        <div class="contents__message-area message--min">
          <div class="contents__message">
            {{ message }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import dayjs from 'dayjs'
import AccountIconWh24 from '../../../atoms/account_icons/AccountIconWh24'
export default {
  components: { AccountIconWh24 },
  props: {
    id: {
      type: Number,
      require: true,
      default: 0
    },
    senderName: {
      type: String,
      require: true,
      default: ''
    },
    senderIconImageUrl: {
      type: String,
      require: true,
      default: ''
    },
    message: {
      type: String,
      require: true,
      default: ''
    },
    receivedAt: {
      type: String,
      require: true,
      default: ''
    },
    cardDesignImageUrl: {
      type: String,
      require: true,
      default: ''
    },
    token: {
      type: String,
      require: true,
      default: ''
    }
  },
  computed: {
    formattedReceivedDate() {
      return dayjs(this.receivedAt).format('YYYY/MM/DD HH:mm')
    }
  },
  methods: {
    moveReceivedGift() {
      location.href = `/r/${this.token}`
    }
  }
}
</script>
